import { useUpdateKnowledgeDocumentsOnBackground } from '@/pages/agents/hooks';
import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import { AgentGrounding, AgentKnowledgeSource } from '@d-id/types';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { GeneralContainer } from '../../common';
import { InputText } from './InputText';
import { KnowledgeSource } from './KnowledgeSource';
import { UploadFiles } from './UploadFiles';

const KNOWLEDGE_SOURCE_TO_COMPONENT = {
    [AgentKnowledgeSource.BaseKnowledge]: InputText,
    [AgentKnowledgeSource.Documents]: UploadFiles,
};

const Title = styled.h3`
    color: ${theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const Container = styled(GeneralContainer)`
    gap: 8px;
`;

const MainContainer = styled(GeneralContainer)`
    gap: 24px;
`;

const InputContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    gap: 16px;

    width: 100%;

    > div {
        display: flex;
        width: 100%;
    }
`;

const KnowledgeSourceInput = observer(() => {
    const agentEditorStore = useAgentEditorStore();
    const knowledgeSource = agentEditorStore.llm.prompt_customization?.knowledge_source;
    const Component = KNOWLEDGE_SOURCE_TO_COMPONENT[knowledgeSource || agentEditorStore.defaultKnowledgeSource];

    return <Component />;
});

export const KnowledgeSourceSelection = observer(() => {
    const agentEditorStore = useAgentEditorStore();
    useUpdateKnowledgeDocumentsOnBackground();

    const fileUploadDisabled = agentEditorStore.llm.template === AgentGrounding.Ungrounded;

    return (
        <Container>
            <Title>How would you like to upload your data?</Title>
            <MainContainer>
                <InputContainer>
                    <div>
                        <KnowledgeSource knowledgeSource={AgentKnowledgeSource.BaseKnowledge} displayName="Input text" />
                    </div>

                    <Tooltip
                        title="File upload is unavailable on Ungrounded mode"
                        placement="top"
                        slotProps={{
                            tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } },
                        }}
                        PopperProps={{
                            modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
                        }}
                        disableHoverListener={!fileUploadDisabled}
                        disableTouchListener={!fileUploadDisabled}
                        disableFocusListener={!fileUploadDisabled}>
                        <div>
                            <KnowledgeSource
                                knowledgeSource={AgentKnowledgeSource.Documents}
                                displayName="Upload files"
                                disabled={fileUploadDisabled}
                            />
                        </div>
                    </Tooltip>
                </InputContainer>
                <div>
                    <KnowledgeSourceInput />
                </div>
            </MainContainer>
        </Container>
    );
});
